import {Component , EventEmitter , Input , OnInit , Output} from '@angular/core';
import {Router} from '@angular/router';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'program-block',
    templateUrl: './program.component.html',
    styleUrls: ['./program.component.scss'],
    standalone: false
})
export class ProgramComponent implements OnInit {
  @Input() color;
  @Input() title;
  @Input() date;
  @Input() closed;
  @Input() info;
  @Input() codeInfo;
  @Input() id;
  @Input() isOnEvent;
  @Input() type = '';
  @Input() completed = false;
  @Input() allInfo;
  @Input() TGForRewards;
  @Output() deleteItem = new EventEmitter();
  @Output() updateRewards = new EventEmitter();

  editTarget = false;
  selectedTG;
  userId;
  subEvents = [];
  rewardsDeleted = false;

  constructor(private router: Router, public frontUserService: FrontUserService,
              public toastr: ToastrService) {}

  ngOnInit() {
    if (this.allInfo &&  this.allInfo.targetGroupId) {
      this.selectedTG = this.allInfo.targetGroupId;
    }
    if (this.info?.subEvent?.length) {
      this.subEvents = this.info?.subEvent.filter(el => el.subEventBooking && el.subEventBooking.length);
    }
    if (this.info?.hasOwnProperty('rewards') && !this.info?.rewards?.length) {
      this.rewardsDeleted = true;
    }
  }

  deleteReward(id) {
    this.deleteItem.emit(id);
  }

  goToEvent(event) {
    if (event && event.id) {
      this.router.navigate([ '/pages/event/detail' ] , {queryParams: {id: event.id}});
    }
  }

  editTG() {
    this.editTarget = true;
  }

  saveTG() {
    this.editTarget = false;
    this.frontUserService.editRewards({id: this.allInfo.id, tgId: this.selectedTG}).subscribe((res: any) => {
      if (res && res.error && res.error === 'rewardsNotFound') {
        this.toastr.error('Reward not found!' , 'Error!');
      }
      if (res && res.id) {
        this.toastr.success('Zielgruppe der Creditbuchung angepasst!' , 'Erfolgreich!');
        this.updateRewards.emit(true);
      }
    });
  }

  cancelEditTG() {
    this.editTarget = false;
  }
}
